var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.19 14.891"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.095.125a3.975 3.975 0 00-3.97 3.97v7.516a.485.485 0 10.971 0V4.095a3 3 0 016 0v7.749a1.954 1.954 0 01-1.951 1.951h-.047a1.954 1.954 0 01-1.951-1.951V7.196a.95.95 0 111.9 0v4.415a.485.485 0 10.971 0V7.196a1.921 1.921 0 10-3.842 0v4.648a2.925 2.925 0 002.922 2.922h.047a2.926 2.926 0 002.922-2.922V4.095A3.975 3.975 0 004.095.125z",
    fill: "#5f48e9",
    stroke: "#5f48e9",
    strokeWidth: 0.25
  })));
}

export default SvgAttachment;